'use strict';

require('./groups/CompanyGroupService.js');
require('./groups/CompanyGroupUserService.js');
require('./publications/CompanyPublicationService.js');
require('./publications/PublicationTypeaheadDirective.js');
require('./users/CompanyUsersTypeahead.js');


function CompanySettingsClassesCtrl(
  $scope,
  $stateParams,
  $state,
  $sce,
  members,
  group,
  growl,
  CompanyGroupService,
  CompanyGroupUserService,
  translations,
  publications,
  CompanyPublicationService
) {
  $scope.members = members;
  $scope.group = group;
  $scope.publications = publications;
  $scope.newPublication = {};

  $scope.page = 0;
  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['members']),
      'content': '',
      'template': 'partials/company/settings/classes/users.html',
      'icon': 'users'
    },
    {
      'title': $sce.trustAsHtml(translations['customer-portals.documents']),
      'content': '',
      'template': 'partials/company/settings/classes/documents.html',
      'icon': 'files-o'
    }
  ];

  $scope.tabs.activeTab = 0;

  $scope.removeMember = function(userId) {
    CompanyGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.groupId, userId: userId}, function() {
      $scope.members = $scope.members.filter(function(item) {
        return item.id !== userId;
      });

      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
    }, function() {
      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
    });
  };

  $scope.removePublication = function(publication) {
    if (publication.groups.indexOf($scope.group.id) > -1) {
      publication.groups.splice(publication.groups.indexOf($scope.group.id), 1);
    }
    CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
      growl.addSuccessMessage(translations['publication.remove-success']);
      $scope.publications.splice($scope.publications.indexOf(publication), 1);
    }, function() {
      growl.addErrorMessage(translations['publication.remove-failure']);
    });
  };

  $scope.updateGroup = function() {
    $scope.group.$update({
      companyId: $stateParams.companyId,
      groupId: $scope.group.id
    }, function(){
      angular.element('#filterRole').val('');
      growl.addSuccessMessage(translations['settings.save-group-success']);
    }, function(){
      growl.addErrorMessage(translations['settings.save-group-failure']);
    });
  };

  $scope.queryPublications = function(page){
    $scope.page = page;
    CompanyPublicationService.query({
      companyId: $stateParams.companyId, 
      groupId: $stateParams.groupId,
      limit: 21,
      offset: (page*20)
    }).$promise.then(function(publications){
      $scope.publications = publications;
      if($scope.publications.length === 21) {
        $scope.more = true;
        $scope.publications.pop();
      }else{
        $scope.more = false;
      }
    });
  };
}

CompanySettingsClassesCtrl.resolve = {
  group: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
    return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}).$promise;
  }],
  members: ['$stateParams', 'CompanyGroupUserService', function($stateParams, CompanyGroupUserService) {
    return CompanyGroupUserService.query({
      companyId: $stateParams.companyId,
      groupId: $stateParams.groupId,
      limit: 200}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'customer-portals.add-member-success',
      'customer-portals.add-member-failure',
      'customer-portals.remove-member-success',
      'customer-portals.remove-member-failure',
      'settings.save-group-success',
      'settings.save-group-failure',
      'members',
      'customer-portals.documents',
      'publication.remove-success',
      'publication.remove-failure'
    ]);
  }],
  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({
      companyId: $stateParams.companyId, 
      groupId: $stateParams.groupId,
      limit: 21
    }).$promise;
  }]
};

module.exports = CompanySettingsClassesCtrl;

angular.module('dokiv')
  .controller('CompanySettingsClassesCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    '$sce',
    'members',
    'group',
    'growl',
    'CompanyGroupService',
    'CompanyGroupUserService',
    'translations',
    'publications',
    'CompanyPublicationService',
    CompanySettingsClassesCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanySettingsClassesCtrl.js
// module id = 315
// module chunks = 0